import React, { useEffect, useState } from "react";
import { NavBar } from "@/components/navbar";
import { useBusinessOnboarding } from "@/hooks/useBusinessOnboarding";
import OnboardingStep from "@/components/business/onboarding/steps/OnboardingStep";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useFirebase } from "@/context/FirebaseProvider"; // Added
import { LoadingScreen } from "@/components/ui/loading-screen";

const GoCampaignPage: React.FC = () => {
  const {
    businessId,
    business,
    step,
    navigateToStep,
    handlePackageSelected,
    handleFinishOnboarding,
    setIsNavigating,
  } = useBusinessOnboarding();

  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const { businesses: allBusinessesFromFirebase, isLoading: firebaseIsLoading } = useFirebase(); // Use useFirebase

  // isLoading state now primarily driven by firebaseIsLoading
  const isLoading = firebaseIsLoading; 

  // allBusinesses for the dropdown is directly from FirebaseProvider
  const allBusinesses = allBusinessesFromFirebase || [];

  // Timer for additional loading delay can be removed or adjusted if still needed for UI reasons
  // For now, relying on firebaseIsLoading.
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsLoading(false); // This local setIsLoading would conflict if firebaseIsLoading is the source of truth
  //   }, 2000);
  //   return () => clearTimeout(timer);
  // }, []);

  // Handle business not found after data had a chance to load
  // useEffect(() => {
  //   if (!isLoading && !business && businessId) {
  //     console.log('GoCampaignPage - Business not found after loading period');
  //     toast({
  //       title: "Business not found",
  //       description: "The requested business could not be found. Redirecting to home.",
  //       variant: "destructive"
  //     });
  //     navigate('/', { replace: true });
  //   }
  // }, [business, businessId, isLoading, navigate, toast]);

  // Custom navigation function for changing businesses on GoCampaign page
  const handleBusinessChange = (id: string) => {
    console.log("GoCampaignPage - handleBusinessChange called with id:", id);

    // Tell the onboarding hook we are in the middle of navigation to prevent redirects
    setIsNavigating(true);

    if (id === "home") {
      navigate("/");
      return;
    }

    // Keep the current step when changing businesses
    const currentStep = step || 0;

    // Build the new URL path directly (don't use regex replacement)
    const newPath = `/business/${id}/gocampaign`;

    // Create search params with the current step
    const searchParams = new URLSearchParams();
    searchParams.set("step", currentStep.toString());
    const queryString = searchParams.toString();

    // Log the navigation for debugging
    console.log(`GoCampaignPage - Navigating to: ${newPath}?${queryString}`);

    // Use REPLACE instead of PUSH to avoid history duplicates
    navigate(`${newPath}?${queryString}`, { replace: true });

    // Reset the navigation flag after a delay
    setTimeout(() => {
      setIsNavigating(false);
    }, 500);
  };

  // Show loading spinner while data is being fetched
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Don't try to render the page if business is not found
  if (!business) {
    return null;
  }

  return (
    <div className="flex flex-col min-h-screen bg-brand-light">
      <NavBar
        businessName={
          business?.displayName || business?.name || "Business Onboarding" // Use displayName or name
        }
        allBusinesses={allBusinesses}
        onBusinessSelect={handleBusinessChange}
        isGoCampaignPage={true}
      />

      <main className="flex-1 px-4 mx-auto w-full max-w-screen-xl md:px-8 animate-fade-in">
        <OnboardingStep
          step={step}
          business={business}
          businessId={businessId}
          onNavigateHome={() => navigateToStep(0)}
          onSetStep={navigateToStep}
          onFinishOnboarding={handleFinishOnboarding}
          onPackageSelected={handlePackageSelected}
        />
      </main>
    </div>
  );
};

export default GoCampaignPage;
